module.exports = __webpack_public_path__ + "img/menu_borde.7fd5c2cc.png";